import { GET_BOOK_SLOT_HASH } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export type Res = { status: string; url?: string; message?: string };

export default ({ id, docid }: { id: string; docid?: string }): Promise<Res> => {
    return fetchWithRefresh(GET_BOOK_SLOT_HASH(id, docid)).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('failed to GET_BOOK_SLOT_HASH');
        }
    });
};
